export default __webpack_public_path__ + "static/media/availability.981178b7.svg";